export const requestWaitingTime = 5000;
export const requestStatusCodes = {
  OK: 200,
  BAD_REQUEST: 400,
  ERROR: 500,
};

export const MY_TRACKER_ID = 3247888;
export const DEV_COUNTER_MY_TRACKER_ID = 3247889;

export const DEV_LANDING_DOMAIN = 'https://www.rustore.ru/developer';
export const DEV_BLOG_FULL_URL = `${DEV_LANDING_DOMAIN}/blog`;

export const DEV_BLOG_CATEGORIES_FULL_URL = `${DEV_BLOG_FULL_URL}/categories`;

export const DEV_BLOG_DEFAULT_TITLE =
  'От идеи до релиза: практические советы для разработчиков игр и приложений на Android';

export const DEV_BLOG_DEFAULT_DESCRIPTION =
  'Ищешь практические советы по разработке игр и приложений для Android? Наш блог поможет тебе пройти путь от идеи до успешного релиза.';
